import axios from "../../utils/axios";

export const getVideos = async (tags, search, currentPage, author) => {
    let queryString = "";

    if (tags?.length > 0) {
        queryString = "&"
        queryString += tags.map((tag) => `tags_like=${tag}`).join("&");
    }

    if (search !== "") {
        queryString += `&q=${search}`;
    }

    if(author !== "") {
        queryString += `&author_like=${author.replaceAll(" ", "%20")}`;
    }

    const response = await axios.get(`/videos/?_page=${currentPage}&_limit=4${queryString}`);

    return {videos: response.data, pages: Math.ceil(response.headers["x-total-count"] / 4)};
};
